import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import isHotkey from 'is-hotkey';
import { ELEMENT_ALIGN_JUSTIFY } from '@udecode/slate-plugins'

import BaseElement from './BaseElement';
import { insertNodeAndScroll } from '../editor-utils'


export function renderStatementElement(params) {
  return (props) => {
    if (props.element.type === 'statement') { 
      return (
          <StatementElement {...props} {...params} />
      );
    }
  
    return undefined;
  }
}

export function onStatementKeyDown(event, editor) {
    if (!editor.selection) return;
 
    const currentNode = editor.children[editor.selection.anchor.path[0]];

    if (currentNode.type === 'statement' && isHotkey('shift+enter', event)) {
      event.preventDefault();
      // editor.insertNode({ type: 'statement', isNew: true, block: currentNode.block + 1, number: currentNode.number + 1, children: [{text: ''}]})
      return false;
    }
}

export function insertStatement(editor, { block, number, text = '', defaultTextAlign = 'justify' }) {
  const node = {
    type: 'statement',
    isNew: true,
    block, 
    number,
    textAlign: defaultTextAlign,
    children: [{ text }] 
  }
  insertNodeAndScroll(editor, node)
}

export const StatementPlugin = (params) => ({
  renderElement: renderStatementElement(params),
  onKeyDown: onStatementKeyDown
});

export default function StatementElement({ attributes, index, element, children, ...props }) {
  const { t } = useTranslation();

  const number = useMemo(() => {
    return element.number ? element.number : element.index
  }, [element.number, element.index])

  return (
    <BaseElement className="Statement-text" element={element} type="statement" {...props} {...attributes}>
      {({ isEmpty }) => (
        <React.Fragment>
          <BaseElement.NoEditableField className="item-title" fontWeight="bold" fontSize={element.fontSize}>
            {number}.{' '}
          </BaseElement.NoEditableField>
          { isEmpty && <BaseElement.Placeholder text={t('editor.items.statement')} /> }
          {/* <span {...attributes}> */}
                  {children}
          {/* </span> */}
        </React.Fragment>
      )}
    </BaseElement>
  )
}
